import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollPositions = new Map<string, number>();
const isMobile = () => window.matchMedia('(max-width: 48em)').matches;

export const ScrollToTop = () => {
  const { key, pathname } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    const save = () => scrollPositions.set(key, window.scrollY);
    window.addEventListener('scroll', save, { passive: true });
    return () => window.removeEventListener('scroll', save);
  }, [key]);

  useLayoutEffect(() => {
    const pathnameChanged = previousPathname.current !== pathname;
    previousPathname.current = pathname;
    if (!isMobile()) return;
    if (navigationType === 'POP') {
      window.scrollTo(0, scrollPositions.get(key) ?? 0);
    } else if (pathnameChanged) {
      window.scrollTo(0, 0);
    }
  }, [key, pathname, navigationType]);

  return null;
};
